export const ROOT_PATH = '/';
export const NOT_FOUND_PATH = '/not-found';
export const REPORT_PATH = '/report/:reportSlug';
export const IMPORT_DATA_PATH = `${REPORT_PATH}/import-data`;
export const IMPORTING_HRIS_DATA_PATH = `${REPORT_PATH}/importing-hris-data`;
export const UPLOAD_FILE_PATH = `${REPORT_PATH}/upload-file`;
export const REVIEW_DATA_PATH = `${REPORT_PATH}/review-data`;
export const ADD_ESTABLISHMENT_DETAILS_PATH = `${REPORT_PATH}/add-establishment-details`;
export const JOB_CATEGORY_CONFIRMATION_PATH = `${REPORT_PATH}/job-category-confirmation`;
export const PREVIEW_REPORT_PATH = `${REPORT_PATH}/preview-report`;
export const DOWNLOAD_REPORT_PATH = `${REPORT_PATH}/download-report`;
export const GUSTO_OAUTH_CALLBACK_PATH = '/integrations/gusto/oauth/callback';
export const HOW_TO_FILE_PATH = '/how-to-file';
